import { SearchForm } from '@calendly/form';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ExportDropdown } from './export_dropdown';
const containerIsPhoneCss = "c8pxgh5";
const containerCss = "c1f8z6j5";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const searchFormContainerIsTabletCss = "svlnv6x";
const searchFormContainerIsDesktopUpCss = "s1ti9pqe";
const searchFormContainerCss = "s42gqpt";
const SearchFormContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTablet = useDeviceType('isTablet');
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(searchFormContainerCss, {
    [searchFormContainerIsTabletCss]: isTablet,
    [searchFormContainerIsDesktopUpCss]: isDesktopUp
  }, props.className)} />;
});
const wrapperIsPhoneCss = "w12w130q";
const wrapperCss = "w17vbhko";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const ControlsContainer = ({
  handleSearch,
  filterTerm,
  isAdminOrOwner
}) => <Container>
    <SearchFormContainer>
      <SearchForm onSearch={handleSearch} initialValue={filterTerm} />
    </SearchFormContainer>
    <Wrapper>
      {isAdminOrOwner && <ExportDropdown />}
    </Wrapper>
  </Container>;

require("./controls_container.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./controls_container.js");